import { render, staticRenderFns } from "./AppleCard.vue?vue&type=template&id=3bf8c2dc&scoped=true"
import script from "./AppleCard.vue?vue&type=script&lang=js"
export * from "./AppleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8c2dc",
  null
  
)

export default component.exports